import { useEffect, useState } from "react";
import HeaderBar from "./HeaderBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { useData } from "./MemberData";
import { Modal, Backdrop, Fade, Box, Checkbox, CheckboxProps } from "@mui/material";
import { JSX } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import '../../styles/style.css'
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { useTheme } from "./ThemeContext";

interface CV{
    user_id: string;
    nume: string;
    link: string;
    reintegrare: Boolean;
    grad: string;
}

function CvPage() {
    const { theme } = useTheme();
    const { membersData } = useData();
    const [myDiscordID, setMyDiscordID] = useState("");
    const [CVModal, openCVModal] = useState(false);
    const [user_id, setUserId] = useState("");
    const [user_name, setUserName] = useState("");
    const [app_link, setAppLink] = useState("");
    const [rGrade, setRGrade] = useState("");
    const [reintegrare, setReintegrare] = useState(false);
    const [CVList, setCVList] = useState<CV[]>([]);

    const loadCV = async () => {
        try {
            const response = await axios.get("http://panelmedici.fplayt.ro:5000/getCV");
            if (response && response.data) {
                setCVList(response.data);
            }
        } catch (err) {
            console.log(err);
            return;
        }
    }

    useEffect(() => {
        const idFromCookies = Cookies.get("myDiscordID") || "";
        setMyDiscordID(idFromCookies);
        loadCV();
    }, []);

    const isConducere = () => {
        for (let index = 0; index < membersData.length; index++) {
            const member = membersData[index];
            if (
            member.discordID === myDiscordID &&
            (member.grade === "Director-General" ||
                member.grade === "Director-Adjunct" ||
                member.grade === "Medic-Inspector" ||
                member.grade === "Medic-Chirurg")
            ) {
                return true;
            }
        }
        return false;
    };

    const upDownStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '35%',
        height: '50%',
        display: 'flex',
        flexDirection: 'column',
        gap: '2%',
        bgcolor: theme === "dark" ? '#191919' : '#d6d6d6',
        boxShadow: 24,
        borderRadius: '.3vw',
        outline: 'none',
        p: 2,
    }

    const handleCVModalClose = () => {
        openCVModal(false);
    }

    const BpIcon = styled('span')(({ theme }) => ({
        borderRadius: 3,
        width: 23,
        height: 23,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
            ...theme.applyStyles('dark', {
            backgroundColor: '#30404d',
            }),
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
            ...theme.applyStyles('dark', {
            background: 'rgba(57,75,89,.5)',
            }),
        },
        ...theme.applyStyles('dark', {
            boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
            backgroundColor: '#394b59',
            backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',
        }),
    }));
      
    const BpCheckedIcon = styled(BpIcon)({
        backgroundColor: '#ff0000',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&::before': {
            display: 'block',
            width: 23,
            height: 23,
            backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#ff0000',
        },
    });
      
    function BpCheckbox(props: JSX.IntrinsicAttributes & CheckboxProps) {
        return (
            <Checkbox
                sx={{ '&:hover': { bgcolor: 'transparent' } }}
                disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                inputProps={{ 'aria-label': 'Checkbox demo' }}
                {...props}
            />
        );
    }

    const sendCV = async () => {
        if (!user_id || !user_name || !app_link) {
            toast.error("Trebuie sa completezi toate campurile!");
            return;
        }
    
        try {
            let token = Cookies.get("accessToken");
            if (!token) {
                toast.error("Nu ai un token de acces valabil!");
                return;
            }
            await axios.post("http://panelmedici.fplayt.ro:5000/createCV", {
                id: user_id,
                name: user_name,
                link: app_link,
                reintegrare: reintegrare,
                grade: rGrade
            }, { headers: { Authorization: `Bearer ${token}` } });
            setUserId("");
            setUserName("");
            setAppLink("");
            setRGrade("");
            setReintegrare(false);
            handleCVModalClose();
            loadCV();
            toast.success("CV-ul a fost creat cu succes!");
        } catch (err) {
            if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                let refreshToken = Cookies.get("refreshToken");
                if (!refreshToken) {
                    toast.error("Nu ai un refresh token valabil!");
                    return;
                }
                const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                    refreshToken: refreshToken
                });
    
                if (refreshResponse.status === 200) {
                    const newAccessToken = refreshResponse.data.accessToken;
                    Cookies.set("accessToken", newAccessToken);
                    try {
                        await axios.post("http://panelmedici.fplayt.ro:5000/createCV", {
                            id: user_id,
                            name: user_name,
                            link: app_link,
                            reintegrare: reintegrare,
                            grade: rGrade
                        }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
    
                        setUserId("");
                        setUserName("");
                        setAppLink("");
                        setRGrade("");
                        setReintegrare(false);
                        handleCVModalClose();
                        loadCV();
                        toast.success("CV-ul a fost creat cu succes!");
                    } catch (err) {
                        toast.error("A aparut o eroare! CV-ul nu a fost creat.");
                    }
                } else {
                    toast.error("Refresh token-ul nu este valid!");
                }
            } else {
                toast.error("A aparut o eroare! CV-ul nu a fost creat.");
            }
        }
    };
    
    const deleteCV = async (id: string) => {
        try {
            const token = Cookies.get("accessToken");
            if (!token) {
                toast.error("Nu ai un token de acces valabil!");
                return;
            }
    
            await axios.post("http://panelmedici.fplayt.ro:5000/deleteCV", { id: id }, { headers: { Authorization: `Bearer ${token}` } });
            loadCV();
            toast.success("CV-ul a fost sters cu succes!");
        } catch (err) {
            if (axios.isAxiosError(err) && err.response && err.response.status === 401) {
                let refreshToken = Cookies.get("refreshToken");
                if (!refreshToken) {
                    toast.error("Nu ai un refresh token valabil!");
                    return;
                }
                const refreshResponse = await axios.post("http://panelmedici.fplayt.ro:5000/api/refresh", {
                    refreshToken: refreshToken
                });
                if (refreshResponse.status === 200) {
                    const newAccessToken = refreshResponse.data.accessToken;
                    Cookies.set("accessToken", newAccessToken);
                    try {
                        await axios.post("http://panelmedici.fplayt.ro:5000/deleteCV", { id: id }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
                        loadCV();
                        toast.success("CV-ul a fost sters cu succes!");
                    } catch (err) {
                        toast.error("A aparut o eroare! CV-ul nu a fost sters.");
                    }
                } else {
                    toast.error("Refresh token-ul nu este valid!");
                }
            } else {
                toast.error("A aparut o eroare! CV-ul nu a fost sters.");
            }
        }
    };
    

    return (
        <div className="w-full h-full flex flex-col">
            <HeaderBar currentPage="Aplicatii" />
            <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
                <div className="w-full h-[7%] flex items-center justify-between">
                    <span className="textSemiBold text-[1.1vw] text-[#000000] dark:text-[#ffffff]">
                        CV-uri Medici
                    </span>
                    {isConducere() && (
                        <div className="w-[60%] h-full flex items-center justify-end gap-[1%]">
                            <div onClick={() => openCVModal(true)} className="min-w-fit h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                                <span className="textBold text-white text-[.8vw]">ADAUGA APLICATIE</span>
                            </div>
                        </div>
                    )}
                </div>
                <div className="bg-white dark:bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
                    {Array.isArray(CVList) && CVList.length > 0 && (
                        CVList.map((data, index) => (   
                            <div key={index} className="w-full min-h-[8%] border-b-[1px] border-[#D0D0D0] flex items-center gap-[1%] border-box pl-[1%]">
                                <span className="textSemiBold w-[4%] text-center text-[0.9vw] text-black dark:text-white">{data.user_id}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <span className="textSemiBold w-[13%] text-center text-[0.9vw] text-black dark:text-white">{data.nume}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <a className="textSemiBold w-[10%] text-center underline text-blue-600 text-[0.9vw]" href={data.link}>Link CV - Forum</a>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <span className={`textSemiBold w-[7%] text-center text-[0.9vw] ${data.reintegrare ? "text-[#7c6398]" : "text-[#9f3f3f]"}`}>{data.reintegrare ? "REINTEGRARE" : "ADMITERE"}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <span className="textSemiBold w-[7%] text-center text-[0.9vw] text-black dark:text-white">{data.grad}</span>
                                <div className="w-[1px] h-[70%] bg-gradient-to-b from-[#00000000] via-[#000000] to-[#00000000] dark:from-[#ffffff00] dark:via-[#ffffff] dark:to-[#ffffff00]"></div>
                                <div onClick={() => deleteCV(data.user_id)} className="min-w-[9%] h-[70%] px-[2%] flex items-center justify-center rounded-[.2vw] cursor-pointer bg-gradient-to-r from-[#c40e0e] to-[#f51818]">
                                    <span className="textBold text-white text-[.8vw]">STERGE</span>
                                </div>
                            </div>
                        ))
                    )}           
                </div>
            </div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={CVModal}
                onClose={handleCVModalClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
                >
                <Fade in={CVModal}>
                <Box sx={upDownStyle} className="flex flex-col items-center">
                    <span className="text-black dark:text-white textSemiBold text-[1vw] w-full text-center">APLICATII CV</span>
                    <input
                        onChange={e => setUserId(e.target.value)}
                        placeholder="Introdu ID"
                        type="text"
                        className="w-[60%] h-[13%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                    />
                    <input
                        onChange={e => setUserName(e.target.value)}
                        placeholder="Introdu Nume"
                        type="text"
                        className="w-[60%] h-[13%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                    />
                    <input
                        onChange={e => setAppLink(e.target.value)}
                        placeholder="Introdu Link CV"
                        type="text"
                        className="w-[60%] h-[13%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                    />
                    <div className="w-[60%] h-[10%] mt-[1%] flex flex-row">
                        <BpCheckbox checked={reintegrare} onChange={(event) => setReintegrare(event.target.checked)} />
                        <span className="textSemiBold text-white text-[1vw] h-full flex items-center">Reintegrare</span>
                    </div>
                    {reintegrare === true && (
                        <input
                            onChange={e => setRGrade(e.target.value)}
                            placeholder="Introdu Grad"
                            type="text"
                            className="w-[60%] h-[13%] mt-[1%] textSemiBold text-center outline-none placeholder-[#868686] text-[#909090] text-[1vw] bg-[#ffffff10] rounded-[2vw] border border-[#323232]"
                        />
                    )}
                    <div onClick={sendCV} className="cursor-pointer mt-[5%] w-[70%] h-[15%] flex items-center justify-center bg-gradient-to-b from-[#D8630F] to-[rgba(245,147,24,0.75)] shadow-[0_2px_0_rgba(0,0,0,0.25)] rounded-[40px]">
                        <span className="text-white textBold text-[1.1vw]">CREEAZA CV</span>
                    </div>
                </Box>
                </Fade>
            </Modal>
            <ToastContainer />
        </div>
    )
}

export default CvPage;